import script from "./FileUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=js"

import "./FileUpload.vue?vue&type=style&index=0&id=dc887e44&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc887e44"]])

export default __exports__